import { useState } from 'react';
import TransactionsList from '../transactions/TransactionsList';
import PerpetualList from '../perpetual/PerpetualList';
import './Registry.css';

/**
 * Реестр с двумя вкладками.
 *
 * Механики независимы: у срочного стейкинга есть срок, ставка за срок и дата
 * разблокировки, у бессрочного — тикающее начисление и расписание выплат.
 * Общих колонок ровно одна (адрес), поэтому сводить их в одну таблицу с
 * прочерками не имеет смысла — это две таблицы, переключаемые вкладкой.
 *
 * Неактивная вкладка не смонтирована: у бессрочной внутри секундный таймер и
 * опрос списка, крутить их в фоне ради невидимой таблицы незачем.
 */

const TERM = 'term';
const PERPETUAL = 'perpetual';

const Registry = ({ refreshKey }) => {
  const [tab, setTab] = useState(TERM);

  return (
    <div className="registry_container">
      <div className="registry_tabs" role="tablist">
        <button
          type="button"
          role="tab"
          aria-selected={tab === TERM}
          className={tab === TERM ? 'registry_tabs__active' : ''}
          onClick={() => setTab(TERM)}
        >
          Срочные
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={tab === PERPETUAL}
          className={tab === PERPETUAL ? 'registry_tabs__active' : ''}
          onClick={() => setTab(PERPETUAL)}
        >
          Бессрочные
        </button>
      </div>

      {tab === TERM ? (
        <TransactionsList refreshKey={refreshKey} />
      ) : (
        <PerpetualList refreshKey={refreshKey} />
      )}
    </div>
  );
};

export default Registry;
